import {
  type TutorialObjective,
  TutorialMessageColors
} from '@powerplay/core-minigames'
import { defineStore } from 'pinia'

export interface TutorialState {
  anne: {
    showAnne: boolean,
    isRight: boolean,
    instructorName: string,
    instructorNameText: string
  },
  mobile: boolean,
  tutorialMessage: {
    message: string,
    showMessage: boolean,
    color: TutorialMessageColors,
    yellowText: string,
    yellowTextSpecial: boolean,
    offset: boolean
  },
  objectives: TutorialObjective[],
  settings: boolean,
  showArrowAim: boolean,
  instructionBoxText: string,
  showInstructionBox: boolean,
  showWind: boolean,
  showTime: boolean,
  resultPoints: number
}

const initialState = (): TutorialState => ({
  anne: {
    showAnne: false,
    isRight: false,
    instructorName: 'longova',
    instructorNameText: 'utTutorialLongova'
  },
  mobile: false,
  tutorialMessage: {
    message: '',
    showMessage: false,
    color: TutorialMessageColors.blank,
    yellowText: '',
    yellowTextSpecial: false,
    offset: false
  },
  settings: false,
  objectives: [],
  showArrowAim: false,
  instructionBoxText: '',
  showInstructionBox: false,
  showWind: false,
  showTime: false,
  resultPoints: 0
})

export const tutorialState = defineStore('tutorialState', {
  state: initialState,
})
